import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { credentialFailureMessage, credentialStatusLabel, credentialStatusVariant } from './credentialStatus';

/**
 * One-line credential state for a utility row on property details.
 *
 * Shows the masked username the API returns and nothing more - no password, no reveal, no request
 * that could produce one. `isVisible` is a convenience for the caller; the real gate is the API's
 * Permissions.AdminOrHigher.
 */
export const UtilityCredentialStatusLine = _ref => {
  let credential = _ref.credential,
    isVisible = _ref.isVisible,
    unavailable = _ref.unavailable;
  if (!isVisible) return null;

  // A chip, not the full WipBanner the pages carry: this renders once per utility row, and a
  // banner per row would bury the property details page it sits on.
  const wip = /*#__PURE__*/React.createElement(Chip, {
    size: "small",
    label: "WIP",
    variant: "warning"
  });

  // A failed lookup leaves an empty list, which is indistinguishable from a property that genuinely
  // has no credentials. Saying "none saved" during an outage sends an operator to create one that
  // may already exist.
  if (unavailable) {
    return /*#__PURE__*/React.createElement(Stack, {
      direction: "row",
      spacing: 1,
      alignItems: "center",
      sx: {
        marginTop: '4px'
      }
    }, wip, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "Credential state unavailable"));
  }
  if (!credential) {
    return /*#__PURE__*/React.createElement(Stack, {
      direction: "row",
      spacing: 1,
      alignItems: "center",
      sx: {
        marginTop: '4px'
      }
    }, wip, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "No portal credentials saved"));
  }
  const failure = credentialFailureMessage(credential);
  return /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: 1,
    alignItems: "center",
    sx: {
      marginTop: '4px'
    },
    flexWrap: "wrap"
  }, wip, /*#__PURE__*/React.createElement(Chip, {
    size: "small",
    label: credentialStatusLabel(credential),
    variant: credentialStatusVariant(credential)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, credential.usernameHint), failure ? /*#__PURE__*/React.createElement(Tooltip, {
    title: failure,
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "Needs attention")) : null);
};